import { useErrorBoundary } from 'preact/hooks';
import type { ComponentChildren } from 'preact';
import { captureBrowserException } from '../lib/sentry';
import { ErrorState } from './ErrorState';
import { t } from '../lib/i18n';

/**
 * Top-level crash boundary for the Creator app. A render-time throw
 * anywhere in the tree is caught here, reported to Sentry, and replaced
 * with the unified branded recovery surface (§12.5) — never a raw stack trace.
 */
export function ErrorBoundary({ children }: { children: ComponentChildren }) {
  const [error] = useErrorBoundary((err) => captureBrowserException(err));
  if (error) {
    return (
      <ErrorState
        variant="crash"
        onPrimary={() => window.location.assign(window.location.pathname)}
        secondaryLabel={t('state.goHome')}
        onSecondary={() => window.location.assign(window.location.pathname + '#')}
      />
    );
  }
  return <>{children}</>;
}
